import React from "react";
import { PolicyNotesList } from "../../PoliciesCommon/PolicyNotes/PolicyNotesList";
import { IActivityModuleInformation } from "../../../../../../components/Activity/Activity.types";

export interface IBusinessPolicyNotesListProps {
  customerId: number;
  customerPolicyId: number;
  moduleInformation: IActivityModuleInformation;
}
export const BusinessPolicyNotesList: React.FC<IBusinessPolicyNotesListProps> = (props) => {
  const { customerId, customerPolicyId, moduleInformation } = props;

  return (
    <PolicyNotesList
      customerId={customerId}
      customerPolicyId={customerPolicyId}
      moduleInformation={moduleInformation}
    />
  );
};
